export default {
  isLoading: false,
  listaSiniestros: [],
  viewDetails: false,

  selectedSiniestro: {},
  lastSiniestro: {},
  atencionesMedicas: [],
  showNoDataAtencionesMedicas: false,
  periodosReposo: [],
  evaluacionesIncapa: [],
  prestacionesEconomicas: [],
  filtrosTablaSiniestro: null,
};
